import axios from 'axios'
import LocalStorage from '@/utils/localstorage'

class CheatDataFactory {
  async validateCheatToken (data: any) {
    try {
      const url = '/validate_cheat_token'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async activateCheatMode (data: any) {
    try {
      const url = '/activate_cheat_mode'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async cheat1 (data: any) {
    data.token = LocalStorage.getOne('cheatToken')
    try {
      const url = '/cheat1'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async cheat2 (data: any) {
    data.token = LocalStorage.getOne('cheatToken')
    try {
      const url = '/cheat2'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async cheat3 (data: any) {
    data.token = LocalStorage.getOne('cheatToken')
    try {
      const url = '/cheat3'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async cheat4 (data: any) {
    data.token = LocalStorage.getOne('cheatToken')
    try {
      const url = '/cheat4'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async cheat5 (data: any) {
    data.token = LocalStorage.getOne('cheatToken')
    try {
      const url = '/cheat5'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async cheat6 (data: any) {
    data.token = LocalStorage.getOne('cheatToken')
    try {
      const url = '/cheat6'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }
}

export const cheatDataFactory = new CheatDataFactory()
